/* OTC theme motion + store layer. Vanilla, reduced-motion aware.
   Cart = Shopify AJAX Cart API. Search = Shopify predictive search API. */
(function () {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const money = (cents) => "$" + (cents / 100).toFixed(2);

  /* ================= cart (Shopify AJAX API) ================= */
  const count = document.querySelector(".cart-count");
  let cartState = null;
  async function fetchCart() {
    cartState = await (await fetch("/cart.js")).json();
    renderCount();
    renderDrawer();
    return cartState;
  }
  function renderCount(pulse) {
    if (!count || !cartState) return;
    count.textContent = cartState.item_count;
    if (pulse) { count.classList.remove("pulse"); void count.offsetWidth; count.classList.add("pulse"); }
  }
  async function addToCart(variantId, qty) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty }),
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      toast(err.description || "That one isn't available right now.");
      return false;
    }
    await fetchCart();
    renderCount(true);
    return true;
  }
  async function changeLine(key, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await fetchCart();
  }

  /* ================= cart drawer: the humidor tray ================= */
  let drawer, drawerList;
  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement("aside");
    drawer.className = "tray";
    drawer.innerHTML =
      '<div class="tray-scrim"></div>' +
      '<div class="tray-panel" role="dialog" aria-label="Your humidor">' +
      '<div class="tray-head"><p class="kicker">Your Humidor</p><button class="tray-close" aria-label="Close">✕</button></div>' +
      '<div class="tray-items"></div>' +
      '<div class="tray-foot">' +
      '<div class="tray-total"><span>Subtotal</span><b></b></div>' +
      '<a class="btn btn-gold tray-checkout" href="/checkout">Checkout</a>' +
      '<p class="tray-note">Shipping and taxes settle at checkout.</p>' +
      "</div></div>";
    document.body.appendChild(drawer);
    drawerList = drawer.querySelector(".tray-items");
    drawer.querySelector(".tray-scrim").addEventListener("click", closeDrawer);
    drawer.querySelector(".tray-close").addEventListener("click", closeDrawer);
    drawer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-tray-qty]");
      if (!btn) return;
      changeLine(btn.dataset.key, Number(btn.dataset.trayQty));
    });
  }
  function renderDrawer() {
    if (!drawerList || !cartState) return;
    if (!cartState.items.length) {
      drawerList.innerHTML =
        '<p class="tray-empty">The humidor is empty.<br><a href="/collections/cigars">The cigars are this way.</a></p>';
    } else {
      drawerList.innerHTML = cartState.items
        .map(
          (i) =>
            '<div class="tray-item">' +
            (i.image ? '<img src="' + i.image + '&width=128" alt="" onerror="this.outerHTML=\'<span class=tray-ph></span>\'">' : '<span class="tray-ph"></span>') +
            '<div class="tray-item-info"><h4>' + i.product_title + "</h4>" +
            (i.variant_title && i.variant_title !== "Default Title" ? '<p style="color:var(--taupe);font-size:11px">' + i.variant_title + "</p>" : "") +
            "<p>" + money(i.final_price) + "</p>" +
            '<div class="tray-qty">' +
            '<button data-tray-qty="' + (i.quantity - 1) + '" data-key="' + i.key + '" aria-label="Less">−</button>' +
            "<span>" + i.quantity + "</span>" +
            '<button data-tray-qty="' + (i.quantity + 1) + '" data-key="' + i.key + '" aria-label="More">+</button>' +
            "</div></div></div>"
        )
        .join("");
    }
    drawer.querySelector(".tray-total b").textContent = money(cartState.items_subtotal_price);
  }
  function openDrawer() { buildDrawer(); renderDrawer(); requestAnimationFrame(() => drawer.classList.add("open")); document.body.style.overflow = "hidden"; }
  function closeDrawer() { drawer?.classList.remove("open"); document.body.style.overflow = ""; }
  document.querySelector(".cart-btn")?.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); });
  fetchCart();

  /* ================= predictive search (Shopify API) ================= */
  let search, seekT;
  function openSearch() {
    if (!search) {
      search = document.createElement("div");
      search.className = "seek";
      search.innerHTML =
        '<div class="seek-scrim"></div><div class="seek-panel">' +
        '<form action="/search" method="get"><input type="search" name="q" placeholder="Search the house..." aria-label="Search" autocomplete="off"></form>' +
        '<div class="seek-results"></div>' +
        '<p class="seek-hint">Esc to close · Enter for all results</p></div>';
      document.body.appendChild(search);
      const input = search.querySelector("input");
      const results = search.querySelector(".seek-results");
      input.addEventListener("input", () => {
        clearTimeout(seekT);
        const q = input.value.trim();
        if (!q) { results.innerHTML = ""; return; }
        seekT = setTimeout(async () => {
          try {
            const r = await (await fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,article,page&resources[limit]=8")).json();
            const rs = r.resources.results;
            const rows = [].concat(
              (rs.products || []).map((p) => ({ t: p.title, s: p.price ? "$" + p.price : "", h: p.url })),
              (rs.articles || []).map((a) => ({ t: a.title, s: "The Locker Room", h: a.url })),
              (rs.pages || []).map((p) => ({ t: p.title, s: "Page", h: p.url }))
            );
            results.innerHTML = rows.length
              ? rows.map((x) => '<a href="' + x.h + '"><b>' + x.t + "</b><span>" + x.s + "</span></a>").join("")
              : '<p class="seek-none">Nothing by that name in the house. Try "cigar", "hoodie", or "box".</p>';
          } catch (e) { /* predictive search unavailable: form submit still works */ }
        }, 180);
      });
      search.querySelector(".seek-scrim").addEventListener("click", closeSearch);
      addEventListener("keydown", (e) => { if (e.key === "Escape") closeSearch(); });
    }
    search.classList.add("open");
    setTimeout(() => search.querySelector("input").focus(), 60);
    document.body.style.overflow = "hidden";
  }
  function closeSearch() { search?.classList.remove("open"); document.body.style.overflow = ""; }
  document.querySelectorAll(".js-search-toggle").forEach((b) => b.addEventListener("click", openSearch));

  /* ================= age gate ================= */
  const gate = document.getElementById("gate");
  if (gate) {
    const KEY = "otc_gate_ok";
    const days = Number(gate.dataset.days || 30);
    const TTL = days * 24 * 3600 * 1000;
    const force = new URLSearchParams(location.search).has("gate");
    const ok = Number(localStorage.getItem(KEY) || 0);
    if (force || !ok || Date.now() - ok > TTL) {
      gate.showModal();
      document.body.style.overflow = "hidden";
    }
    gate.addEventListener("cancel", (e) => e.preventDefault());
    document.getElementById("gate-yes").addEventListener("click", () => {
      localStorage.setItem(KEY, Date.now());
      if (reduced) { gate.close(); document.body.style.overflow = ""; return; }
      gate.classList.add("opening");
      setTimeout(() => { gate.close(); document.body.style.overflow = ""; }, 700);
    });
    document.getElementById("gate-no").addEventListener("click", () => {
      document.getElementById("gate-denied").textContent =
        "Come back when you're of age. We'll keep a chair warm.";
    });
  }

  /* ================= header / mobile menu ================= */
  const head = document.querySelector(".site-head");
  const onScroll = () => head && head.classList.toggle("scrolled", scrollY > 40);
  addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  const mmenu = document.querySelector(".mmenu");
  document.querySelector(".burger")?.addEventListener("click", () => mmenu.classList.add("show"));
  mmenu?.querySelector(".close")?.addEventListener("click", () => mmenu.classList.remove("show"));

  /* ================= scroll reveals ================= */
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add("in"), io.unobserve(e.target))),
    { threshold: 0.18 }
  );
  document.querySelectorAll(".reveal, .rule").forEach((el) => io.observe(el));

  /* ================= view-transition name gating =================
     Names pair only when the click happened on the morphing element. */
  let lastClick = null;
  document.addEventListener("click", (e) => { lastClick = e.target.closest("a, button"); }, true);
  const clickOwns = (el) => !!(lastClick && el && (lastClick === el || lastClick.contains(el) || el.contains(lastClick)));

  if ("onpageswap" in window) {
    addEventListener("pageswap", (e) => {
      if (!e.viewTransition || !e.activation?.entry?.url) return;
      const to = new URL(e.activation.entry.url);
      document.querySelectorAll("[data-vt]").forEach((el) => (el.style.viewTransitionName = "none"));
      let el = null, name = null;
      const pm = to.pathname.match(/\/products\/([a-z0-9-]+)/);
      if (pm) {
        name = "product-" + pm[1];
        el = document.querySelector('[data-vt="' + name + '"]');
      } else if (/\/collections\/cigars/.test(to.pathname)) {
        name = "coll-cigars";
        el = document.querySelector('.humidor [data-vt="coll-cigars"]');
      }
      if (el && clickOwns(el.closest("a") || el)) {
        el.style.viewTransitionName = name;
        sessionStorage.setItem("otc_vt_pair", name);
      } else {
        sessionStorage.removeItem("otc_vt_pair");
      }
    });
    addEventListener("pagereveal", (e) => {
      const pair = sessionStorage.getItem("otc_vt_pair");
      sessionStorage.removeItem("otc_vt_pair");
      if (!e.viewTransition) return;
      document.querySelectorAll("[data-vt]").forEach((el) => {
        const name = el.dataset.vt;
        let keep = false;
        if (pair && name === pair) {
          if (el.id === "pdp-frame" && /\/products\//.test(location.pathname)) keep = true;
          if (name === "coll-cigars" && /\/collections\/cigars/.test(location.pathname) && !el.closest(".humidor")) keep = true;
        }
        el.style.viewTransitionName = keep ? name : "none";
      });
    });
  }

  /* ================= collection filters + sort (instant) ================= */
  const grid = document.querySelector(".pgrid[data-filterable]");
  if (grid) {
    const cards = Array.from(grid.children);
    document.querySelectorAll(".pill").forEach((p) =>
      p.addEventListener("click", () => {
        document.querySelectorAll(".pill").forEach((x) => x.setAttribute("aria-pressed", x === p ? "true" : "false"));
        const f = p.dataset.filter;
        cards.forEach((c) => {
          const tags = (c.dataset.tags || "").split(" ");
          const show = f === "all" || (f === "stock" ? c.dataset.stock === "1" : tags.includes(f));
          c.style.display = show ? "" : "none";
        });
      })
    );
    document.querySelector(".sort select")?.addEventListener("change", (e) => {
      const v = e.target.value;
      let order = Array.from(cards);
      if (v === "asc") order.sort((a, b) => a.dataset.price - b.dataset.price);
      if (v === "desc") order.sort((a, b) => b.dataset.price - a.dataset.price);
      order.forEach((c) => grid.appendChild(c));
    });
  }

  /* ================= bfcache restore ================= */
  addEventListener("pageshow", (e) => {
    document.querySelectorAll(".cigar.pick").forEach((c) => c.classList.remove("pick"));
    document.querySelectorAll(".humidor.open").forEach((h) => h.classList.remove("open"));
    if (e.persisted) fetchCart();
  });

  /* ================= humidor doors ================= */
  document.querySelectorAll(".humidor").forEach((tile) => {
    tile.addEventListener("click", (e) => {
      const href = tile.getAttribute("href");
      if (!href || href === "#") return;
      e.preventDefault();
      if (reduced) { location.href = href; return; }
      tile.classList.add("open");
      setTimeout(() => (location.href = href), 460);
    });
  });

  /* ================= cigar box ================= */
  document.querySelectorAll(".cigar").forEach((c) => {
    c.addEventListener("click", (e) => {
      e.preventDefault();
      if (reduced) { location.href = c.href; return; }
      c.classList.add("pick");
      setTimeout(() => (location.href = c.href), 320);
    });
  });

  /* ================= size pills: pick a real variant ================= */
  document.querySelectorAll(".sizes").forEach((row) => {
    row.addEventListener("click", (e) => {
      const s = e.target.closest(".size");
      if (!s) return;
      row.querySelectorAll(".size").forEach((x) => x.setAttribute("aria-pressed", x === s ? "true" : "false"));
      const btn = row.closest(".piece-info")?.querySelector("[data-add-to-cart]");
      if (btn && s.dataset.variantId) btn.dataset.variantId = s.dataset.variantId;
    });
  });

  /* ================= add to cart: arc into the humidor ================= */
  document.querySelectorAll("[data-add-to-cart]").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const qty = Number(btn.closest("section")?.querySelector(".qty input")?.value || 1);
      const vid = btn.dataset.variantId;
      if (!vid) { toast("Pick a size first."); return; }
      let img = document.querySelector(btn.dataset.addToCart);
      if (img && img.closest(".is-ph")) img = null;
      const cartIcon = document.querySelector(".cart-btn");
      if (img && cartIcon && !reduced && "animate" in Element.prototype) {
        const a = img.getBoundingClientRect(), b = cartIcon.getBoundingClientRect();
        const ghost = img.cloneNode();
        ghost.className = "fly-img";
        ghost.style.left = a.left + a.width / 2 - 45 + "px";
        ghost.style.top = a.top + a.height / 2 - 56 + "px";
        document.body.appendChild(ghost);
        ghost.animate(
          [
            { transform: "translate(0,0) scale(1)", opacity: 1 },
            { transform: `translate(${(b.left - a.left - a.width / 2 + 45) * 0.6}px, ${b.top - a.top - a.height / 2 - 120}px) scale(.55)`, opacity: 0.9, offset: 0.55 },
            { transform: `translate(${b.left - a.left - a.width / 2 + 45}px, ${b.top - a.top - a.height / 2 + 56}px) scale(.12)`, opacity: 0.4 },
          ],
          { duration: 550, easing: "cubic-bezier(.4,0,.2,1)" }
        ).onfinish = () => ghost.remove();
      }
      const ok = await addToCart(vid, qty);
      if (ok) toast("Added to your humidor: <em>" + (btn.dataset.title || "1 item") + "</em>");
    });
  });

  /* story: on expand, smooth-scroll the full text into view */
  document.querySelectorAll("details.story-more").forEach((d) => {
    d.addEventListener("toggle", () => {
      if (!d.open) return;
      const full = d.querySelector(".story-full");
      if (full) full.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  /* qty stepper */
  document.querySelectorAll(".qty").forEach((q) => {
    const input = q.querySelector("input");
    q.querySelector("[data-minus]")?.addEventListener("click", () => (input.value = Math.max(1, +input.value - 1)));
    q.querySelector("[data-plus]")?.addEventListener("click", () => (input.value = +input.value + 1));
  });

  /* ================= toast ================= */
  let toastEl, toastT;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    requestAnimationFrame(() => toastEl.classList.add("show"));
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove("show"), 2600);
  }
  window.otcToast = toast;
})();
